import beautifyJson from './beautifyJson';

function getJsonSummary(data) {
    let charLimit = 200;
    let strData;

    if (!data) {
        return '';
    }

    strData = beautifyJson(data);

    if (strData.length < charLimit) {
        return strData;
    } else {
        return strData.substring(0, charLimit) + '...';
    }
}

export default getJsonSummary;
